import { render, staticRenderFns } from "./room-participants-push-item.vue?vue&type=template&id=56773d12"
import script from "./room-participants-push-item.vue?vue&type=script&lang=js"
export * from "./room-participants-push-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports